import React from "react"
import Artifact from "../artifact";
import Video from "../../video/Video";
import Figure from "../figure";

const Gargaresh = () => {
  return (
    <Artifact>
      <Figure
        creditPosition="top-left"
        caption="Meeting with Soumahoro in Gargaresh"
        captionSize="small"
        captionAlign="left"
      >
        <Video
          src="https://cdn.theoutlawocean.com/al-mabani/clips__gargaresh.mp4"
          muted="muted"
          autoplay="autoplay"
          loop="loop"
        />
      </Figure>
    </Artifact>
  )
};

export default Gargaresh;